import { createReducer, on } from "@ngrx/store";
import { AppState } from "../../app.reducer";
import { setUser, unSetUser } from './user.actions';

export interface State {
    data: any;
    isLoggedIn: boolean;
}

export interface AppStateUser extends AppState {
    data: State,
    isLoggedIn: boolean
}

export const initialState: State = {
    data: null,
    isLoggedIn: false
}

const _userReducer = createReducer(initialState,
    on(setUser, (state, { data }) => ({ ...state, data, isLoggedIn: true })),
    on(unSetUser, state => ({ ...state, data: null, isLoggedIn: false }))
);

export function userReducer(state: any, action: any) {
    return _userReducer(state, action);
}